
import {defineComponent} from "vue";
import {mapActions, mapGetters} from "vuex";
import {stringHasContent} from "@/helpers/functions/string";

export default defineComponent({
  name: "ProductSelectionTrademarksFilters",
  emits: ["submit"],
  computed: {
    ...mapGetters('cpc_mgmt', ['getSearchTrademarkName']),
    searchQuery: {
      get(): string | undefined {
        return this.getSearchTrademarkName;
      },
      set(value: string) {
        (value.length > 0) ? this.setSearchTrademarkName(value) : this.clearSearchTrademarkName();
      },
    },
    hasSearchQuery(): boolean {
      return stringHasContent(this.searchQuery);
    },
  },
  mounted() {
    this.clearSearchTrademarkName();
  },
  methods: {
    ...mapActions('cpc_mgmt', [
      'clearSearchTrademarkName',
      'setSearchTrademarkName',
    ]),
    async clearSearch() {
      this.clearSearchTrademarkName();
      this.$emit('submit');
    },
  }
});
